<template>
  <div v-if="loader" class="card-data expanded-cluster">
    <div class="header-cluster">
      <button class="expand" @click="$emit('hideCluster', null)">
            <i class="icon ico-minimize"></i>
      </button>
      <div class="card-title">
        <h5 class="title">{{cluster}}</h5>
        <small class="sub-title">{{sub}}</small>
        <div class="venues">
            <i class="icon ico-venue"></i>
            <small class="venue">{{venues}} sedes</small>
        </div>
      </div>
    </div>
    <div class="data-container">
      <div class="left"> 
        <div class="ranking">
          <!-- <RevenueClusterCard
          :data="stores"
          :loader="loader"
          :totalRevenue="totalRevenue"
          /> -->
        </div>
        <div class="total-average">
          <small class="title">Conexiones</small>
          <div class="total">
            <p class="number">{{thousandseparatos(totalConnections)}}</p>
            <small class="desc">Totales</small>
          </div>
          <div class="total average">
            <p class="number">{{thousandseparatos(averageConnections)}}</p>
            <small class="desc">Prom. sucursal</small>
          </div>
        </div>
        <div class="total-average">
          <small class="title">Visitantes</small>
          <div class="total">
            <p class="number">{{thousandseparatos(totalVisitors)}}</p>
            <small class="desc">Totales</small>
          </div>
          <div class="total average">
            <p class="number">{{thousandseparatos(averageVisitors)}}</p>
            <small class="desc">Prom. sucursal</small>
          </div>
        </div>
        <div class="total-average">
          <small class="title">Transeúntes</small>
          <div class="total">
            <p class="number">{{thousandseparatos(totalPasserby)}}</p>
            <small class="desc">Totales</small>
          </div>
          <div class="total average">
            <p class="number">{{thousandseparatos(averagePasserby)}}</p>
            <small class="desc">Prom. sucursal</small>
          </div>
        </div>
        
      </div>
      <div class="right">
        <LineGraphCard class="charts"
        title="Conexiones"
        :sub="thousandseparatos(totalConnections)"
        :responsive="true"
        :data="dataLine"
        :periodItems="periodItemsLine"
        :loader="loader"
        titleEmpty="Este gráfico no está disponible actualmente"
        captionEmpty="Preferimos no presentar este gráfico mientras no contemos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
        height="200px"
        tip="Gráfico que muestra el total de conexiones al portal cautivo de las sedes del cluster en función del tiempo."
        />
        
        <!-- <BarGraphCard class="charts"
        title="Interacciones"
        :responsive="true"
        :sub="thousandseparatos(totalInteractions)"
        :data="data"
        :periodItems="periodItems"
        :loader="loader"
        height="200px"
        tip="Gráfico que muestra el total de interacciones con contenidos de las sucursales del cluster en función del tiempo."
        /> -->
        
      </div>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
import RevenueClusterCard from "@/components/cards/RevenueClusterCard"
import LineGraphCard from "@/components/cards/LineGraphCard"
import BarGraphCard from "@/components/cards/BarGraphCard"
import Loader from '@/components/Loader'
export default {
  name: 'ClusterCard',
  components: {
    RevenueClusterCard,
    LineGraphCard,
    BarGraphCard,
    Loader
    },
    props: {
        sub:{
          type: String,
          required: true
        },
        cluster: {
            type: String,
            required: true
        },
        venues: {
            type: Number,
            required: true
        },
        totalConnections:{
          type: Number,
          required: true
        },
        averageConnections:{
          type: String,
          required: true
        },
        loader:{
          type: Boolean,
          required: true
        },
        totalVisitors:{
          type: Number,
          default: 0
        },
        averageVisitors:{
          type: String,
          required: true
        },
        totalPasserby:{
          type: Number,
          required: true
        },
        averagePasserby:{
          type: String,
          required: true
        },
        totalInteractions:{
          type: Number,
          required:true
        },
        stores:{
          type: Array,
          required: true
        },
        totalRevenue:{
          type: String,
          required: true
        },
        data:{
          type: Array,
          required: true
        },
        periodItems:{
          type: Array,
          required: true
        },
        dataLine:{
          type: Array,
          required: true
        },
        periodItemsLine:{
          type: Array,
          required: true
        }
    },
    methods: {
        thousandseparatos: function(num){
            
            try {
                let num_parts = []
                num = parseInt(num)
                if (num > 999999){
                  num = ((num / 1000000).toFixed(1))
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                  num_parts = num_parts+" MM"
                }else{
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                }

                return num_parts
            } catch (error) {
                return error
            }
        },
    },
}
</script>

<style lang="sass">
.card-data.expanded-cluster
  padding-bottom: 8px
  display: grid
  grid-template-columns: 8px 1fr 8px 1fr 8px
  grid-template-rows: 8px 80px 8px auto 8px
  @include mobile
    grid-template-columns: 8px 1fr 8px
    grid-template-rows: 8px auto 8px auto 8px
  .header-cluster
    grid-column: 2/5
    grid-row: 2/3
    margin-top: 0px
    @include mobile
      grid-column: 2/3
  .card-title h5
    margin-top: $xs
  button.expand
    background: $lighter-grey
    border-radius: 2px
    border: none
    padding: 2px
    position: absolute
    top: 8px
    right: 8px
    width: 20px
    height: 20px
    cursor: pointer
    color: $dark-grey
    &:hover
      background: $default
      color: $secondary
    .icon
      font-size: 16px
      margin: 0
  .venues
    margin-top: $xxs
    background: $default
    max-width: 128px
    border-radius: $xxs
    box-sizing: border-box
    padding: 2px $xxs 
    display: flex
    aling-items: center
    color: $dark
    .icon
      height: 16px
      width: 16px
      color: $dark
      font-size: 16px
      margin: 0
    .venue
      margin-left: $xxs
  .data-container
    grid-column: 2/5
    grid-row: 4/5
    display: grid
    height: auto
    grid-template-columns: auto 8px 2fr
    @include mobile
      grid-column: 2/3
      grid-row: 4/5
      display: flex
      flex-direction: column
    .left
      grid-column: 1/2
      display: flex
      flex-direction: column
      .card-data.ranking
        margin-top: 8px
        // height: 80px
        height: 124px
        padding-top: 8px
        overflow: auto
      .total-average
        display: flex
        flex-wrap: wrap
        // width: 250px
        width: 100%
        border: 1px solid $default
        padding: 1px
        border-radius: 4px
        font-family: $title-font
        max-height: 80px
        box-sizing: border-box
        margin-top: 8px
        justify-content: center
        @include mobile
          width: 100%
        .title
          width: 100%
          font-weight: 100
          font-size: 14px
          height: 24px
        .total.average
          // width: 60%
          width: 40%
        .total
          width: 40%
          display: flex
          flex-direction: column
          height: 48px
          justify-content: center
          align-items: center
          p.number
            font-size: 20px
            font-weight: 600
          small.desc
            font-weight: 100
            font-size: 12px
    .right
      grid-column: 3/4
      width: 100%
      display: flex
      flex-direction: column
      .charts
        height: 95%
        margin-top: 8px
        .card-title h5
          font-size: 14px
        small 
          font-size: 14px
          font-weight: bold
</style>